/** Tamil content keyed by department id */
export const DATA_TA = {
  1: {
    minister: "மின்சாரம்",
    dept: "மின்சாரத் துறை",
    short: "மின்சாரம்",
    payments: [
      { name: "மின்சாரக் கட்டணம் (குறை மின்னழுத்தம்)", desc: "வீடு மற்றும் கடைகளுக்கான குறை மின்னழுத்த மின்சாரக் கட்டணம்" },
      { name: "மின்சாரக் கட்டணம் (உயர் மின்னழுத்தம்)", desc: "தொழில்துறை உயர் மின்னழுத்த மின்சாரக் கட்டணம்" },
      { name: "புதிய சேவை இணைப்பு", desc: "புதிய மின்சார இணைப்புக்கான கட்டணம்" },
      { name: "மீட்டர் வைப்புத்தொகை மற்றும் கட்டணங்கள்", desc: "மீட்டர் எச்சரிக்கை வைப்புத்தொகை, வளர்ச்சிக் கட்டணங்கள்" },
    ],
  },
  2: {
    minister: "நகராட்சி நிர்வாகம் மற்றும் குடிநீர் வழங்கல்",
    dept: "நகராட்சி நிர்வாகம் மற்றும் குடிநீர் வழங்கல் துறை",
    short: "நகராட்சி நிர்வாகம் மற்றும் குடிநீர் வழங்கல்",
    payments: [
      { name: "சென்னை குடிநீர் வரி", desc: "சென்னை மாநகர குடிநீர் வழங்கல் வாரிய குடிநீர் மற்றும் கழிவுநீர் கட்டணம்" },
      { name: "சென்னை சொத்து வரி", desc: "பெருநகர சென்னை மாநகராட்சி சொத்து வரி" },
      { name: "தமிழ்நாடு நகர்ப்புற நகராட்சி வரி", desc: "அனைத்து நகர்ப்புற உள்ளாட்சி அமைப்புகளுக்கான சொத்து வரி" },
      { name: "கோயம்புத்தூர் சொத்து மற்றும் குடிநீர் வரி", desc: "கோயம்புத்தூர் மாநகராட்சி சொத்து மற்றும் குடிநீர் வரி" },
      { name: "மதுரை சொத்து வரி", desc: "மதுரை மாநகராட்சி சொத்து வரி" },
      { name: "திருச்சிராப்பள்ளி சொத்து வரி", desc: "திருச்சி மாநகராட்சி சொத்து வரி ஆன்லைன் கட்டணம்" },
      { name: "ஈரோடு சொத்து மற்றும் குடிநீர் வரி", desc: "ஈரோடு மாநகராட்சி சொத்து மற்றும் குடிநீர் வரி" },
      { name: "கட்டடத் திட்ட அனுமதிக் கட்டணம்", desc: "சென்னை மாநகர வளர்ச்சி ஆணையம் கட்டடத் திட்டம் மற்றும் அமைப்புத் திட்டக் கட்டணம்" },
      { name: "நகராட்சி தொழில்முறை வரி", desc: "நகர்ப்புற உள்ளாட்சி அமைப்புகளுக்கான தொழில்முறை வரி" },
      { name: "வணிக உரிமக் கட்டணம் (நகர்ப்புறம்)", desc: "நகராட்சிகளில் வணிக உரிமம் புதுப்பித்தல் மற்றும் புதிய உரிமம்" },
      { name: "நிலத்தடி வடிகால் வரி", desc: "நிலத்தடி வடிகால் இணைப்பு மற்றும் ஆண்டு வடிகால் வரி" },
      { name: "குடிநீர் மற்றும் நிலத்தடி வடிகால் வைப்புத்தொகை", desc: "புதிய குடிநீர் மற்றும் நிலத்தடி வடிகால் இணைப்பு வைப்புத்தொகை" },
    ],
  },
  3: {
    minister: "ஊரக வளர்ச்சி மற்றும் ஊராட்சி ராஜ்",
    dept: "ஊரக வளர்ச்சி மற்றும் ஊராட்சி ராஜ் துறை",
    short: "ஊரக வளர்ச்சி மற்றும் ஊராட்சி ராஜ்",
    payments: [
      { name: "கிராம ஊராட்சி சொத்து வரி", desc: "பன்னிரண்டாயிரத்து ஐநூற்று இருபத்தைந்து கிராம ஊராட்சிகளுக்கான ஊரக சொத்து வரி" },
      { name: "கிராம ஊராட்சி குடிநீர் கட்டணம்", desc: "ஊரக குடிநீர் வழங்கல் கட்டணம்" },
      { name: "கிராம ஊராட்சி தொழில்முறை வரி", desc: "ஊரகப் பகுதிகளில் தொழில்முறை வரி" },
      { name: "வணிக உரிமக் கட்டணம் (ஊரகம்)", desc: "கிராம ஊராட்சிகளில் வணிகம் மற்றும் கடை உரிமம்" },
    ],
  },
  4: {
    minister: "வர்த்தக வரி மற்றும் பதிவு",
    dept: "வர்த்தக வரி மற்றும் பதிவுத் துறை",
    short: "வர்த்தக வரி மற்றும் பதிவு",
    payments: [
      { name: "தொழில்முறை வரி (முதலாளி)", desc: "முதலாளி தொழில்முறை வரிக் கட்டணம்" },
      { name: "தொழில்முறை வரி (பணியாளர்)", desc: "பணியாளர் தொழில்முறை வரிக் கட்டணம்" },
      { name: "சேர்க்கை வரி / வர்த்தக வரி", desc: "சேர்க்கை வரி மற்றும் வர்த்தக வரிக் கட்டணம்" },
      { name: "சேர்க்கை வரி ஆன்லைன் கட்டணம்", desc: "நேரடி ஆன்லைன் சேர்க்கை வரி கட்டணம்" },
      { name: "சரக்கு மற்றும் சேவை வரிக் கட்டணம்", desc: "சரக்கு மற்றும் சேவை வரி செலுத்துச்சீட்டு உருவாக்கம் மற்றும் ஆன்லைன் கட்டணம்" },
      { name: "முத்திரைத் தீர்வை", desc: "பதிவுக்கு முன் சொத்து முத்திரைத் தீர்வை" },
      { name: "சொத்துப் பதிவுக் கட்டணம்", desc: "ஆவணப் பதிவுக் கட்டணம்" },
      { name: "சிறு நிதி நிறுவனப் பதிவு", desc: "சிறு நிதி நிறுவனப் பதிவுக் கட்டணம்" },
    ],
  },
  5: {
    minister: "போக்குவரத்து",
    dept: "போக்குவரத்துத் துறை",
    short: "போக்குவரத்து",
    payments: [
      { name: "சாலை வரி (வாகனம்)", desc: "வாகனங்களுக்கான ஆண்டு அல்லது வாழ்நாள் சாலை வரி" },
      { name: "ஓட்டுநர் உரிமக் கட்டணம்", desc: "ஓட்டுநர் உரிம விண்ணப்பம், புதுப்பித்தல், தேர்வுக் கட்டணம்" },
      { name: "வாகனப் பதிவுக் கட்டணம்", desc: "புதிய வாகனப் பதிவு மற்றும் பதிவுச் சான்றுக் கட்டணம்" },
      { name: "பொருத்தம் சான்றிதழ் கட்டணம்", desc: "வணிக வாகனப் பொருத்தம் சான்றிதழ்" },
      { name: "அனுமதிச் சீட்டுக் கட்டணம்", desc: "வணிக வாகனங்களுக்கான போக்குவரத்து அனுமதி" },
      { name: "போக்குவரத்து அபராதம்", desc: "போக்குவரத்து விதிமீறல் அபராதம் ஆன்லைன் கட்டணம்" },
    ],
  },
  6: {
    minister: "சுகாதாரம் மற்றும் குடும்ப நலம்",
    dept: "சுகாதாரம் மற்றும் குடும்ப நலத்துறை",
    short: "சுகாதாரம் மற்றும் குடும்ப நலம்",
    payments: [
      { name: "மருந்து உரிமக் கட்டணம்", desc: "மருந்தகம் மற்றும் மருந்துக் கடை உரிமக் கட்டணம்" },
      { name: "அரசு மருத்துவமனைக் கட்டணம்", desc: "அரசு மருத்துவமனைகளில் வெளிநோயாளி, உள்நோயாளி, அறுவைச் சிகிச்சைக் கட்டணம்" },
      { name: "மருத்துவ நிறுவனப் பதிவுக் கட்டணம்", desc: "தனியார் மருத்துவமனை மற்றும் மருத்துவமனைப் பதிவு" },
      { name: "தமிழ்நாடு சுகாதாரத் துறை சேவைகள்", desc: "சுகாதாரத் துறை உரிமங்கள் மற்றும் திட்டக் கட்டணம்" },
    ],
  },
  7: {
    minister: "பள்ளிக் கல்வி",
    dept: "பள்ளிக் கல்வித் துறை",
    short: "பள்ளிக் கல்வி",
    payments: [
      { name: "பல்கலைப்பருவத் தேர்வுக் கட்டணம்", desc: "பத்தாம் மற்றும் பன்னிரண்டாம் வகுப்பு பல்கலைப்பருவத் தேர்வுக் கட்டணம் மற்றும் பதிவு" },
      { name: "பள்ளிச் சான்றிதழ் கட்டணம்", desc: "மாற்றுச் சான்றிதழ், மதிப்பெண் தாள், இடம்பெயர்ச்சிச் சான்றிதழ் கட்டணம்" },
    ],
  },
  8: {
    minister: "உயர் கல்வி",
    dept: "உயர் கல்வித் துறை",
    short: "உயர் கல்வி",
    payments: [
      { name: "அண்ணா பல்கலைக்கழகத் தேர்வுக் கட்டணம்", desc: "அண்ணா பல்கலைக்கழக இணைப்புக் கல்லூரிகளுக்கான தேர்வுப் பதிவு மற்றும் கட்டணம்" },
      { name: "பாரதிதாசன் பல்கலைக்கழகக் கட்டணம்", desc: "பாரதிதாசன் பல்கலைக்கழக மாணவர்களுக்கான தேர்வு, சேர்க்கை மற்றும் சான்றிதழ் கட்டணம்" },
      { name: "சென்னைப் பல்கலைக்கழகக் கட்டணம்", desc: "சென்னைப் பல்கலைக்கழக மாணவர்களுக்கான தேர்வு மற்றும் பாடக் கட்டணம்" },
      { name: "மதுரை காமராஜ் பல்கலைக்கழகக் கட்டணம்", desc: "மதுரை காமராஜ் பல்கலைக்கழக மாணவர்களுக்கான தேர்வு மற்றும் பாடக் கட்டணம்" },
      { name: "பாரதியார் பல்கலைக்கழகக் கட்டணம்", desc: "பாரதியார் பல்கலைக்கழக தேர்வு மற்றும் சேர்க்கைக் கட்டணம்" },
      { name: "பெரியார் பல்கலைக்கழகக் கட்டணம்", desc: "பெரியார் பல்கலைக்கழக மாணவர்களுக்கான தேர்வு மற்றும் பாடக் கட்டணம்" },
      { name: "அழகப்பா பல்கலைக்கழகக் கட்டணம்", desc: "அழகப்பா பல்கலைக்கழக தேர்வு மற்றும் சேர்க்கைக் கட்டணம்" },
      { name: "தமிழ்நாடு மருத்துவப் பல்கலைக்கழகக் கட்டணம்", desc: "மருத்துவம் மற்றும் சார்ந்த சுகாதாரப் பாடங்களுக்கான தேர்வுக் கட்டணம்" },
      { name: "கல்லூரிச் சேர்க்கைக் கட்டணம்", desc: "அரசுக் கல்லூரி சேர்க்கை மற்றும் கல்விக் கட்டணம்" },
      { name: "தமிழ்நாடு பொதுநுழைவுத் தேர்வு விண்ணப்பக் கட்டணம்", desc: "தமிழ்நாடு பொதுநுழைவுத் தேர்வுக் கட்டணம்" },
    ],
  },
  9: {
    minister: "தொழிலாளர் மற்றும் வேலைவாய்ப்பு",
    dept: "தொழிலாளர் மற்றும் வேலைவாய்ப்புத் துறை",
    short: "தொழிலாளர் மற்றும் வேலைவாய்ப்பு",
    payments: [
      { name: "தொழிற்சாலை உரிமக் கட்டணம்", desc: "தொழிற்சாலைச் சட்டத்தின் கீழ் தொழிற்சாலைப் பதிவு மற்றும் புதுப்பித்தல்" },
      { name: "கொதிகலன் சான்றிதழ் கட்டணம்", desc: "கொதிகலன் ஆய்வு மற்றும் சான்றிதழ் கட்டணம்" },
      { name: "கடைகள் மற்றும் நிறுவனப் பதிவுக் கட்டணம்", desc: "கடைப் பதிவு மற்றும் புதுப்பித்தல் கட்டணம்" },
      { name: "ஊழியர் மாநிலக் காப்பீட்டு பங்களிப்பு", desc: "ஊழியர் மாநிலக் காப்பீட்டு பங்களிப்புகள்" },
      { name: "ஊழியர் நலநிதிப் பங்களிப்பு", desc: "ஊழியர் நலநிதி முதலாளிப் பங்களிப்புகள்" },
    ],
  },
  10: {
    minister: "தொழில்கள்",
    dept: "தொழில்கள் துறை",
    short: "தொழில்கள்",
    payments: [
      { name: "குறு மற்றும் நடுத்தர தொழில் நிறுவனப் பதிவுக் கட்டணம்", desc: "குறு நிறுவனப் பதிவு மற்றும் சான்றிதழ் கட்டணம்" },
      { name: "ஒரே சாளர அனுமதிகள்", desc: "இருநூற்றுக்கும் மேற்பட்ட வணிக அனுமதிகள் மற்றும் எதிர்ப்பற்ற சான்றுக் கட்டணம்" },
      { name: "தொழில்கள் துறை எதிர்ப்பற்ற சான்று", desc: "தொழில்களுக்கான மாசுக் கட்டுப்பாடு, தீ பாதுகாப்பு எதிர்ப்பற்ற சான்று" },
    ],
  },
  11: {
    minister: "உள்துறை, தடைச்சட்டம் மற்றும் வரி",
    dept: "உள்துறை, தடைச்சட்டம் மற்றும் வரித் துறை",
    short: "உள்துறை, தடைச்சட்டம் மற்றும் வரி",
    payments: [
      { name: "வரித் துறை உரிமக் கட்டணம்", desc: "மதுபான உரிமம், பார் உரிமக் கட்டணம் — ஆன்லைன் மூலம்" },
      { name: "காவல்துறை எதிர்ப்பற்ற சான்றுக் கட்டணம்", desc: "காவல்துறை சரிபார்ப்பு மற்றும் எதிர்ப்பற்ற சான்றுக் கட்டணம்" },
      { name: "துப்பாக்கி உரிமக் கட்டணம்", desc: "துப்பாக்கி உரிம விண்ணப்பம் மற்றும் புதுப்பித்தல்" },
    ],
  },
  12: {
    minister: "சட்டம்",
    dept: "சட்டத் துறை",
    short: "சட்டம்",
    payments: [
      { name: "நீதிமன்றத் தாக்கல் கட்டணம்", desc: "தமிழ்நாடு நீதிமன்றங்களில் சிவில், குற்ற வழக்குத் தாக்கல் கட்டணம்" },
      { name: "நீதிமன்ற அபராதக் கட்டணம்", desc: "நீதிமன்றம் விதித்த அபராதம் மற்றும் தண்டனைக் கட்டணம்" },
      { name: "அங்கீகரிப்பாளர் மற்றும் வழக்கறிஞர் கட்டணம்", desc: "அரசு அங்கீகரிப்பாளர் மற்றும் சட்டச் சேவைக் கட்டணம்" },
    ],
  },
  13: {
    minister: "வருவாய் மற்றும் பேரிடர் மேலாண்மை",
    dept: "வருவாய் மற்றும் பேரிடர் மேலாண்மைத் துறை",
    short: "வருவாய் மற்றும் பேரிடர் மேலாண்மை",
    payments: [
      { name: "நில வருவாய் / பட்டா கட்டணம்", desc: "நிலப் பதிவு, பட்டா, சிட்டா விண்ணப்பக் கட்டணம்" },
      { name: "சான்றிதழ் விண்ணப்பக் கட்டணம்", desc: "சமூகம், வருமானம், பிறப்பிடச் சான்றிதழ்கள்" },
      { name: "நில அளவீட்டுக் கட்டணம்", desc: "அளவீடு மற்றும் நிலமானியத் துறைக் கட்டணம்" },
      { name: "மாவட்ட மின்னாட்சி சேவைகள்", desc: "வருவாய்ச் சான்றிதழ்கள், ஓய்வூதியம் மற்றும் திட்ட விண்ணப்பங்கள் ஆன்லைன் கட்டணத்துடன்" },
      { name: "மாற்றுத்திறனாளி ஓய்வூதியம்", desc: "வருவாய் ஓய்வூதியத் திட்ட விண்ணப்பம் மற்றும் கட்டணம் மாவட்ட மின்னாட்சி வழியாக" },
    ],
  },
  14: {
    minister: "சுற்றுலா, கலாச்சாரம் மற்றும் இந்து சமய அறநிலையங்கள்",
    dept: "சுற்றுலா, கலாச்சாரம் மற்றும் இந்து சமய அறநிலையங்கள் துறை",
    short: "சுற்றுலா, கலாச்சாரம் மற்றும் இந்து சமய அறநிலையங்கள்",
    payments: [
      { name: "கோயில் நன்கொடை", desc: "இந்து சமய அறநிலையங்கள் கோயில்களுக்கான நன்கொடை" },
      { name: "கோயில் முன்பதிவுக் கட்டணம்", desc: "கோயில்களில் சிறப்புப் பூஜை மற்றும் தரிசன முன்பதிவு" },
      { name: "சுற்றுலாத் துறைக் கட்டணம்", desc: "வழிகாட்டி உரிமம், விடுதிப் பதிவுக் கட்டணம்" },
    ],
  },
  15: {
    minister: "நிதி",
    dept: "நிதித்துறை",
    short: "நிதி",
    payments: [
      { name: "கருவூலம் மின்னணு செலுத்துச்சீட்டு", desc: "அனைத்து அரசுக் கட்டணச் செலுத்துச்சீட்டுகளுக்கான அதிகாரப்பூர்வ தமிழ்நாடு கருவூலம் வாயில்" },
      { name: "கருவூலக் கட்டணம்", desc: "மாநில அரசு நிலுவைத் தொகைகள் வழியாக ஆன்லைன் கட்டணம்" },
      { name: "அரசு ஊழியர் மின்னணு வாயில்", desc: "அரசு ஊழியர் சம்பளம், விடுப்பு மற்றும் பணிப் பதிவுகள்" },
      { name: "ஓய்வூதியர்கள் வாயில்", desc: "தமிழ்நாடு அரசு ஓய்வூதியர்களுக்கான ஓய்வூதிய அறிக்கை மற்றும் கட்டண வரலாறு" },
    ],
  },
  16: {
    minister: "வீட்டுவசதி மற்றும் நகர்ப்புற மேம்பாடு",
    dept: "வீட்டுவசதி மற்றும் நகர்ப்புற மேம்பாட்டுத் துறை",
    short: "வீட்டுவசதி மற்றும் நகர்ப்புற மேம்பாடு",
    payments: [
      { name: "தமிழ்நாடு வீட்டுவசதி வாரியம் குடியிருப்பு முன்பதிவுக் கட்டணம்", desc: "தமிழ்நாடு வீட்டுவசதி வாரியம் குடியிருப்பு விண்ணப்பம் மற்றும் இடப்பணை" },
      { name: "கட்டடத் திட்டக் கட்டணம்", desc: "கட்டடத் திட்ட அனுமதி, அமைப்புத் திட்ட அனுமதி" },
      { name: "தமிழ்நாடு நகர்ப்புற வாழ்விட மேம்பாட்டு வாரியக் கட்டணம்", desc: "தமிழ்நாடு நகர்ப்புற வாழ்விட மேம்பாட்டு வாரியம் வீட்டுவசதி விண்ணப்பக் கட்டணம்" },
    ],
  },
  17: {
    minister: "விவசாயம் மற்றும் விவசாயிகள் நலம்",
    dept: "விவசாயம் மற்றும் விவசாயிகள் நலத்துறை",
    short: "விவசாயம் மற்றும் விவசாயிகள் நலம்",
    payments: [
      { name: "பூச்சிக்கொல்லி உரிமக் கட்டணம்", desc: "பூச்சிக்கொல்லி விற்பனையாளர் உரிமப் பதிவு மற்றும் புதுப்பித்தல்" },
      { name: "உர விற்பனையாளர் உரிமம்", desc: "உர விற்பனையாளர் உரிமப் பதிவுக் கட்டணம்" },
      { name: "தமிழ்நாடு விவசாய விதை வளர்ச்சிக் கட்டணம்", desc: "விவசாயத் துறை விதை மற்றும் உள்ளீட்டுத் திட்டக் கட்டணம்" },
      { name: "விதைச் சான்றிதழ் கட்டணம்", desc: "விதைச் சோதனை மற்றும் சான்றிதழ் கட்டணம்" },
      { name: "பிரதமர் விவசாயிகள் உதவித் தொகைத் திட்டம்", desc: "விவசாயிகள் திட்ட விண்ணப்பம் மற்றும் நிலை" },
    ],
  },
  18: {
    minister: "கூட்டுறவு, உணவு மற்றும் நுகர்வோர் பாதுகாப்பு",
    dept: "கூட்டுறவு, உணவு மற்றும் நுகர்வோர் பாதுகாப்புத் துறை",
    short: "கூட்டுறவு, உணவு மற்றும் நுகர்வோர் பாதுகாப்பு",
    payments: [
      { name: "பொது விநியோக அட்டை சேவைக் கட்டணம்", desc: "அறிவுசார் பொது விநியோக அட்டை விண்ணப்பக் கட்டணம்" },
      { name: "நியாய விலைக் கடை உரிமம்", desc: "பொது விநியோக முறைக் கடை உரிமம் மற்றும் புதுப்பித்தல் கட்டணம்" },
    ],
  },
  19: {
    minister: "குறு, சிறு மற்றும் நடுத்தர தொழில் நிறுவனங்கள்",
    dept: "குறு, சிறு மற்றும் நடுத்தர தொழில் நிறுவனங்கள் துறை",
    short: "குறு, சிறு மற்றும் நடுத்தர தொழில் நிறுவனங்கள்",
    payments: [
      { name: "குறு மற்றும் நடுத்தர தொழில் நிறுவனக் கடன் விண்ணப்பக் கட்டணம்", desc: "தமிழ்நாடு சிறு மற்றும் நடுத்தர தொழில் நிறுவனங்கள் வளர்ச்சிக் கழகம் கடன் விண்ணப்பக் கட்டணம்" },
      { name: "தொழில்துறை இட முன்பதிவு", desc: "மாநில தொழில்துறை மேம்பாட்டுக் கழகம் இட முன்பதிவுக் கட்டணம், இடப்பணை மற்றும் செயலாக்கக் கட்டணம்" },
      { name: "தமிழ்நாடு தொழில்துறை மேம்பாட்டுக் கழகம் தொழில்துறை சேவைகள்", desc: "தமிழ்நாடு தொழில்துறை மேம்பாட்டுக் கழகம் தொழில்துறை உள்கட்டமைப்பு மற்றும் இடச் சேவைகள்" },
    ],
  },
  20: {
    minister: "நெடுஞ்சாலைகள் மற்றும் சிறிய துறைமுகங்கள்",
    dept: "நெடுஞ்சாலைகள் மற்றும் சிறிய துறைமுகங்கள் துறை",
    short: "நெடுஞ்சாலைகள் மற்றும் சிறிய துறைமுகங்கள்",
    payments: [
      { name: "விரைவுச் சாலைக் கட்டண அட்டை நிரப்புதல்", desc: "சுங்கச்சாவடிக் கட்டணத்திற்கான விரைவுச் சாலைக் கட்டண அட்டை பணப்பை நிரப்புதல்" },
      { name: "ஏலக் கட்டணம் (நெடுஞ்சாலைகள்)", desc: "சாலை மற்றும் உள்கட்டமைப்பு ஏல இடப்பணை" },
    ],
  },
  21: {
    minister: "சுற்றுச்சூழல் மற்றும் வனங்கள்",
    dept: "சுற்றுச்சூழல் மற்றும் வனத்துறை",
    short: "சுற்றுச்சூழல் மற்றும் வனங்கள்",
    payments: [
      { name: "வனப்பொருள் கட்டணம்", desc: "மரம் மற்றும் வனப்பொருள் போக்குவரத்து அனுமதிச் சீட்டுக் கட்டணம்" },
      { name: "மாசுக் கட்டுப்பாட்டு ஒப்புதல் கட்டணம்", desc: "தமிழ்நாடு மாசுக் கட்டுப்பாட்டு வாரியம் நிறுவுதல் / இயக்க ஒப்புதல் கட்டணம்" },
      { name: "மின்சார இயந்திர ஆய்வுக் கட்டணம்", desc: "மின்சார ஆய்வாணையம் கட்டணம் கருவூல மின்னணு செலுத்துச்சீட்டு வழியாக" },
    ],
  },
  22: {
    minister: "தகவல் தொழில்நுட்பம் மற்றும் மின்னணு சேவைகள்",
    dept: "தகவல் தொழில்நுட்பம் மற்றும் மின்னணு சேவைகள் துறை",
    short: "தகவல் தொழில்நுட்பம் மற்றும் மின்னணு சேவைகள்",
    payments: [
      { name: "மின்னாட்சி மைய சேவைக் கட்டணம்", desc: "மின்னாட்சி மையங்கள் வழியாக சான்றிதழ் மற்றும் ஆவணச் சேவைகள்" },
      { name: "மின்னாட்சி குடிமகன் வாயில்", desc: "சுய சேவை அரசு விண்ணப்பங்கள் ஆன்லைன் கட்டணத்துடன்" },
      { name: "தமிழ்நாடு மாவட்ட மின்னாட்சி வாயில்", desc: "மாவட்ட அளவிலான சான்றிதழ்கள் மற்றும் திட்டச் சேவைகள்" },
      { name: "பொது சேவை மைய மின்னணு சேவைக் கட்டணம்", desc: "பொது சேவை மைய மின்னாட்சி சேவைகள்" },
    ],
  },
  23: {
    minister: "தறிகை, கைவினைப்பொருட்கள், ஜவுளி மற்றும் காதி",
    dept: "தறிகை, கைவினைப்பொருட்கள், ஜவுளி மற்றும் காதித் துறை",
    short: "தறிகை, கைவினைப்பொருட்கள், ஜவுளி மற்றும் காதி",
    payments: [
      { name: "கூட்டுறவு ஜவுளி கழகம் காட்சியறை முன்பதிவு", desc: "கூட்டுறவு ஜவுளி கழகம் ஆணை மற்றும் முன்பதிவுக் கட்டணம்" },
    ],
  },
  24: {
    minister: "பொதுப்பணிகள்",
    dept: "பொதுப்பணித் துறை",
    short: "பொதுப்பணிகள்",
    payments: [
      { name: "பொதுப்பணி ஏலக் கட்டணம்", desc: "பொதுப்பணி ஏல இடப்பணை மற்றும் ஆவணக் கட்டணம்" },
      { name: "கட்டட வாடகை / குத்தகைக் கட்டணம்", desc: "அரசுக் கட்டட வாடகை மற்றும் குத்தகைக் கட்டணம்" },
    ],
  },
  25: {
    minister: "நீர்வளம்",
    dept: "நீர்வளத் துறை",
    short: "நீர்வளம்",
    payments: [
      { name: "நீர்வள ஏலக் கட்டணம்", desc: "பாசனம் மற்றும் நீர் திட்ட ஏல இடப்பணை" },
      { name: "நீர் பயன்பாட்டுக் கட்டணம்", desc: "பாசன நீர் வரி மற்றும் பயன்பாட்டுக் கட்டணம்" },
    ],
  },
  26: {
    minister: "கால்நடை வளர்ப்பு, பால் பண்ணை மற்றும் மீன்வளம்",
    dept: "கால்நடை வளர்ப்பு, பால் பண்ணை, மீன்வளம் மற்றும் மீனவர் நலத்துறை",
    short: "கால்நடை வளர்ப்பு, பால் பண்ணை மற்றும் மீன்வளம்",
    payments: [
      { name: "ஆவின் பால் அட்டை புதுப்பித்தல்", desc: "மாதாந்திர ஆவின் பால் சந்தா கட்டணம் (ஒவ்வொரு மாதமும் முதல் முதல் பன்னிரண்டாம் தேதி வரை)" },
      { name: "ஆவின் பால் அட்டை பதிவு", desc: "புதிய ஆவின் பால் அட்டை ஆன்லைன் பதிவு" },
      { name: "மீன்வளத் துறை சேவைகள்", desc: "மீன்பிடித் துறை உரிமப் படிவங்கள், நலத் திட்டங்கள் மற்றும் துறைமுகச் சேவைகள்" },
    ],
  },
  27: {
    minister: "இளைஞர் நலன் மற்றும் விளையாட்டு",
    dept: "இளைஞர் நலன் மற்றும் விளையாட்டு வளர்ச்சித் துறை",
    short: "இளைஞர் நலன் மற்றும் விளையாட்டு",
    payments: [
      { name: "விளையாட்டு வளர்ச்சி ஆணையம் விளையாட்டுப் பதிவு", desc: "தமிழ்நாடு விளையாட்டு நிகழ்வுகளுக்கான வீரர், பயிற்சியாளர் மற்றும் பொதுமக்கள் பதிவு" },
      { name: "விளையாட்டு வசதி முன்பதிவு", desc: "அரசு விளையாட்டு உள்கட்டமைப்பு மற்றும் போட்டிக் கட்டணம்" },
    ],
  },
  28: {
    minister: "சமூகநலம் மற்றும் பெண் உரிமையேற்றம்",
    dept: "சமூகநலம் மற்றும் பெண் உரிமையேற்றத் துறை",
    short: "சமூகநலம் மற்றும் பெண் உரிமையேற்றம்",
    payments: [
      { name: "திருமண உதவித் திட்டம்", desc: "மூவலூர் இராமாமிர்தம் மற்றும் தொடர்புடைய திருமண உதவி மின்னாட்சி வழியாக" },
      { name: "பெண் குழந்தை பாதுகாப்புத் திட்டம்", desc: "பெண் குழந்தை நலத் திட்ட விண்ணப்பம் மற்றும் சேவைக் கட்டணம்" },
      { name: "விதவை மறுமண உதவி", desc: "தர்மாம்பாள் அம்மையார் விதவை மறுமண உதவித் திட்டம்" },
      { name: "சமூகநல ஆணையர் அலுவலகம்", desc: "சமூகநலத் திட்டங்கள் மற்றும் திட்டத் தகவல்" },
    ],
  },
  29: {
    minister: "மாற்றுத்திறனாளிகள் நலன்",
    dept: "மாற்றுத்திறனாளிகள் நலத்துறை",
    short: "மாற்றுத்திறனாளிகள் நலன்",
    payments: [
      { name: "துணைக்கருவி விண்ணப்பம்", desc: "சக்கர நாற்காலி, செவித்துணைக்கருவி மற்றும் துணைக்கருவிகளுக்கு விண்ணப்பம்" },
      { name: "பராமரிப்பு உதவித்தொகைத் திட்டம்", desc: "மாற்றுத்திறனாளிகளுக்கான மாதாந்திர பராமரிப்பு உதவித்தொகை" },
      { name: "மாற்றுத்திறனாளிகள் நலத்துறை", desc: "மாற்றுத்திறனாளிகள் நலன் ஆணையர் அலுவலகம்" },
    ],
  },
  30: {
    minister: "ஆதிதிராவிடர் மற்றும் பழங்குடியினர் நலன்",
    dept: "ஆதிதிராவிடர் மற்றும் பழங்குடியினர் நலத்துறை",
    short: "ஆதிதிராவிடர் மற்றும் பழங்குடியினர் நலன்",
    payments: [
      { name: "ஆதிதிராவிடர் நலத்துறை உதவித்தொகை வாயில்", desc: "ஆதிதிராவிடர் மற்றும் பழங்குடியினர் மாணவர்களுக்கான பிந்தைய பள்ளிக் கல்வி உதவித்தொகை" },
      { name: "பழங்குடியினர் நலத் திட்டங்கள்", desc: "பழங்குடியினர் மாணவர் உதவித்தொகை மாவட்ட மின்னாட்சி வழியாக" },
    ],
  },
  31: {
    minister: "பிற்படுத்தப்பட்டவர், மிகப் பிற்படுத்தப்பட்டவர் மற்றும் சிறுபான்மையினர் நலன்",
    dept: "பிற்படுத்தப்பட்டவர், மிகப் பிற்படுத்தப்பட்டவர் மற்றும் சிறுபான்மையினர் நலத்துறை",
    short: "பிற்படுத்தப்பட்டவர், மிகப் பிற்படுத்தப்பட்டவர் மற்றும் சிறுபான்மையினர் நலன்",
    payments: [
      { name: "பிற்படுத்தப்பட்டவர் / மிகப் பிற்படுத்தப்பட்டவர் உதவித்தொகை வாயில்", desc: "பிற்படுத்தப்பட்டவர், மிகப் பிற்படுத்தப்பட்டவர் மற்றும் பழங்குடியினர் மாணவர்களுக்கான பிந்தைய பள்ளிக் கல்வி உதவித்தொகை" },
      { name: "பிற்படுத்தப்பட்டவர் நலத் திட்டங்கள்", desc: "பிற்படுத்தப்பட்ட வகுப்பினர் மற்றும் சிறுபான்மையினருக்கான நலத் திட்டங்கள்" },
      { name: "சிறுபான்மையினர் நிறுவன நிலைக் கட்டணம்", desc: "கல்வி நிறுவனங்களுக்கு சிறுபான்மையினர் நிலை வழங்குதல்" },
    ],
  },
  32: {
    minister: "இயற்கை வளங்கள்",
    dept: "இயற்கை வளங்கள் துறை",
    short: "இயற்கை வளங்கள்",
    payments: [
      { name: "சுரங்கம் மற்றும் புவியியல் துறை", desc: "கல்குவாரி குத்தகை, கனிம ஆய்வு மற்றும் உரிமைத் தகவல்" },
      { name: "சுரங்கக் குத்தகை விண்ணப்பக் கட்டணம்", desc: "சிறு கனிம கல்குவாரி குத்தகை இடப்பணை மற்றும் விண்ணப்பம் கருவூலம் வழியாக" },
    ],
  },
  33: {
    minister: "மனிதவள மேலாண்மை",
    dept: "மனிதவள மேலாண்மைத் துறை",
    short: "மனிதவள மேலாண்மை",
    payments: [
      { name: "அரசு ஊழியர் மின்னணு சேவைகள்", desc: "ஊழியர் விடுப்பு, சம்பளம் மற்றும் பணிப் புத்தக மேலாண்மை" },
      { name: "மனிதவள செலுத்துச்சீட்டுக் கட்டணம்", desc: "அரசு ஊழியர் தொடர்பான கருவூல செலுத்துச்சீட்டுக் கட்டணம்" },
    ],
  },
  34: {
    minister: "திட்டமிடல், வளர்ச்சி மற்றும் சிறப்புத் திட்டங்கள்",
    dept: "திட்டமிடல், வளர்ச்சி மற்றும் சிறப்புத் திட்டங்கள் துறை",
    short: "திட்டமிடல், வளர்ச்சி மற்றும் சிறப்புத் திட்டங்கள்",
    payments: [
      { name: "கட்டடத் திட்ட அனுமதிக் கட்டணம்", desc: "ஆன்லைன் கட்டடத் திட்டம் மற்றும் அமைப்புத் திட்ட அனுமதி கட்டணத்துடன்" },
      { name: "திட்டமிடல் திட்ட ஏலக் கட்டணம்", desc: "சிறப்புத் திட்ட ஏல இடப்பணை" },
    ],
  },
  35: {
    minister: "தமிழ் வளர்ச்சி மற்றும் தகவல்",
    dept: "தமிழ் வளர்ச்சி மற்றும் தகவல்த் துறை",
    short: "தமிழ் வளர்ச்சி மற்றும் தகவல்",
    payments: [
      { name: "தமிழ் வெளியீடு மற்றும் சான்றிதழ் கட்டணம்", desc: "தமிழ் வளர்ச்சித் துறை வெளியீடு மற்றும் சான்றிதழ் சேவைகள் மின்னாட்சி வழியாக" },
    ],
  },
  36: {
    minister: "சமூக சீர்திருத்தம்",
    dept: "சமூக சீர்திருத்தத் துறை",
    short: "சமூக சீர்திருத்தம்",
    payments: [
      { name: "இனப்பெருக்கத் திருமண உதவி", desc: "மருத்துவர் முத்துலட்சுமி ரெட்டி இனப்பெருக்கத் திருமண உதவித் திட்டம்" },
      { name: "சமூக சீர்திருத்தத் திட்டக் கட்டணம்", desc: "மின்னாட்சி மையங்கள் வழியாக சமூக சீர்திருத்த நலத் திட்டங்கள்" },
    ],
  },
  37: {
    minister: "பொது (தேர்தல்)",
    dept: "பொது (தேர்தல்) துறை",
    short: "பொது (தேர்தல்)",
    payments: [
      { name: "தேர்தல் வேட்பாளர் வைப்புத்தொகை", desc: "வேட்பாளர் பாதுகாப்பு வைப்புத்தொகை மற்றும் தேர்தல் கட்டணம்" },
    ],
  },
};
